module.exports = __webpack_public_path__ + "img/campus-follower-verdoppeln.2c45fb3f.svg";